var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-expansion-panel',_vm._b({staticClass:"expansion_panel_border",class:{ 'outlined-card': _vm.outlined }},'v-expansion-panel',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }